import { LOCALE_CODES } from '@yescapa-dev/ysc-components/i18n'
import type { AvailableLocaleCodes } from '~/utils/types'

export type SlugRoutingRule = 'django-cancel-booking' | 'django-rental-contract'
export type ManualRoutingRule = { to: string }
export type ReferentialRoutingRule = { routingKey: string }
export type LocaleRules = Partial<Record<SlugRoutingRule, ManualRoutingRule | ReferentialRoutingRule>>

/*
 * Rules for associated plugin.
 * external true concatenate django url
 * translate true apply localePath method
 */
export const RULES: Partial<Record<AvailableLocaleCodes, LocaleRules>> = {
  [LOCALE_CODES.CA]: {
    'django-cancel-booking': {
      to: '/anular-una-reserva/',
    },
    'django-rental-contract': {
      routingKey: 'contract',
    },
  },
  [LOCALE_CODES.DE]: {
    'django-cancel-booking': {
      to: '/eine-reservierung-stornieren/',
    },
    'django-rental-contract': {
      routingKey: 'contract',
    },
  },
  [LOCALE_CODES.EN]: {
    'django-cancel-booking': {
      to: '/cancel-a-booking/',
    },
    'django-rental-contract': {
      routingKey: 'contract',
    },
  },
  [LOCALE_CODES.ES]: {
    'django-cancel-booking': {
      to: '/anular-una-reserva/',
    },
    'django-rental-contract': {
      routingKey: 'contract',
    },
  },
  [LOCALE_CODES.FR]: {
    'django-cancel-booking': {
      to: '/annuler-une-reservation/',
    },
    'django-rental-contract': {
      routingKey: 'contract',
    },
  },
  [LOCALE_CODES.IT]: {
    'django-cancel-booking': {
      to: '/annullare-una-prenotazione/',
    },
    'django-rental-contract': {
      routingKey: 'contract',
    },
  },
  [LOCALE_CODES.NL]: {
    'django-cancel-booking': {
      to: '/boeking-annuleren/',
    },
    'django-rental-contract': {
      routingKey: 'contract',
    },
  },
  [LOCALE_CODES.NL_BE]: {
    'django-cancel-booking': {
      to: '/reservatie-annuleren/',
    },
    'django-rental-contract': {
      routingKey: 'contract',
    },
  },
  [LOCALE_CODES.PT]: {
    'django-cancel-booking': {
      to: '/cancelar-uma-reserva/',
    },
    'django-rental-contract': {
      routingKey: 'contract',
    },
  },
}
